
import moment from 'moment';
import { Component, Vue, Mixins } from 'vue-property-decorator';
import { getDrawsList } from '@/api/extension-withdrawal';
import { PageQuery } from '@/mixins/page_query';
import { iSelectOptionsList } from '../../../interface/cancel-detail';
@Component({
  filters: {
    local_time_str(val: number) {
      return moment(val * 1000).format('YYYY-MM-DD HH:mm:ss');
    },
  },
})
export default class extends Mixins(PageQuery) {
  private start!: any;
  private end!: any;
  private dataValue: (string | Date)[] = [];
  loading: boolean = false;
  total: number = 0;
  private pickerBeginDateBefore: { disabledDate: Function } = {
    disabledDate(time: any) {
      return time.getTime() > Date.now();
    },
  };
  private payStatuses: iSelectOptionsList[] = [
    {
      value: 1,
      label: '成功',
    },
    {
      value: 2,
      label: '失败',
    },
  ];
  private payStus = '';
  private completedStas = 0;

  private tableData = [];
  private payTp = 0;
  paramsInfo = {
    start: 0,
    end: 0,
    state: '',
    nickname: '',
    uid: '',
    page: 1,
    size: 30,
  };
  searchList() {
    this.getRecordList();
  }
  dataChange(datavalue: Date[]) {
    if (!datavalue) {
      this.paramsInfo.start = 0;
      this.paramsInfo.end = 0;
      this.paramsInfo.page = 1;
      this.getRecordList();
      return;
    }
    this.paramsInfo.start = Math.floor(datavalue[0].getTime() / 1000);
    this.paramsInfo.end = Math.floor(datavalue[1].getTime() / 1000) + 3600 * 24 - 1;
    this.paramsInfo.page = 1;
    this.getRecordList();
  }
  handleSizeChange(size: number) {
    this.paramsInfo.size = size;
    this.paramsInfo.page = 1;
    this.getRecordList();
  }
  handleCurrentChange(page: number) {
    this.paramsInfo.page = page;
    this.getRecordList();
  }
  async getRecordList() {
    this.loading = true;
    const res = await getDrawsList(this.paramsInfo);
    if (res && res.code == 0) {
      this.tableData = res.data.list;
      this.total = res.data.total;
    }
    this.loading = false;
  }
  mounted() {
    this.getRecordList();
  }
}
